import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import {
  Spin,
  Card,
  Button,
  Typography,
  Modal,
  Select,
  Row,
  Col,
  Input,
  DatePicker,
} from "antd";

import InputLabel from "../../../../Components/FloatingSelectLabel/FloatingSelectLabel";
import Notification from "../../../../Components/Notification";
import {
  resetPropertyDetailResponse,
  updatePropertyDetail,
} from "../../../../actionCreators/Property";
import moment from "moment";
import { KHASRA_NUMBER_REGEX, MESSAGES } from "../../../../utils/constants";

const { Title, Text } = Typography;

function LookupTableEdit({
  updatePropertyDetail,
  updatePropertyDetailResponse,
  resetPropertyDetailResponse,
}) {
  const styles = {
    tableRow: { backgroundColor: "lightgray" },
    leftCol: {
      backgroundColor: "white",
      marginRight: "2px",
      paddingBottom: "20px",
    },
    rightCol: { backgroundColor: "white", paddingBottom: "20px" },
    tableHeader: { marginLeft: "20px", marginTop: "25px" },
    tableContentLeft: { marginLeft: "20px", marginTop: "15px" },
    tableContentRight: { marginLeft: "20px", marginTop: "19px" },
    tableContentLeftLabel: {
      marginBottom: "-3px",
      color: "#7f7e7e",
      fontSize: "14px",
    },
    tableContentLeftValue: { fontSize: "16px" },
    tableContentRightValue: { height: "60px", paddingTop: "13px" },
    titleButtonParent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    uploadButton: {
      padding: "7px 18px",
      background: "#284F68",
      color: "white",
      borderRadius: "5px",
      fontWeight: "500",
      fontSize: "15px",
      cursor: "pointer",
      marginRight: "8px",
    },
    titleText: {
      color: "#9e9e9e",
    },
    firstButton: {
      marginRight: "10px",
    },
  };

  const history = useHistory();
  const measurementUnits = ["MARLA"];
  const propertyClassification = ["COMMERCIAL", "RESIDENTIAL"];

  const [disableUpdate, setDisableUpdate] = React.useState(false);
  const [district, setDistrict] = React.useState(null);
  const [tehsil, setTehsil] = React.useState(null);
  const [qanoongoi, setQanoongoi] = React.useState(null);
  const [mouza, setMouza] = React.useState(null);
  const [classification, setClassification] = React.useState(null);
  const [khasraNumber, setKhasraNumber] = React.useState(null);
  const [dcRate, setDcRate] = React.useState(null);
  const [unitOfMeasurement, setUnitOfMeasurement] = React.useState(null);
  const [structureRate, setStructureRate] = React.useState(null);
  const [highwayName, setHighwayName] = React.useState(null);
  const [propertyPrevious, setPropertyPrevious] = React.useState(null);
  const [effectiveDate, setEffectiveDate] = React.useState(moment());
  const [showEffectiveDateModal, setShowEffectiveDateModal] =
    React.useState(false);
  const [isRatesChanged, setIsRatesChanged] = React.useState(false);
  // const [highwayStPnt, setHighwayStPnt] = React.useState(null);
  // const [highwayEndPnt, setHighwayEndPnt] = React.useState(null);
  const [khasraNumberError, setKhasraNumberError] = React.useState("");


  const onStructureRateChange = (e) => {
    setIsRatesChanged(true);
    isNaN(e) || setStructureRate(e);
  };
  const onDcRateChange = (e) => {
    setIsRatesChanged(true);
    isNaN(e) || setDcRate(e);
  };
  const handleSubmit = () => {
    const khasraNumberValidation = validateKhasraNumber(khasraNumber);
    if(!khasraNumberValidation) {
      return
    }
    const requestObj = {
      oldData: propertyPrevious,
      updatedData: {
        district,
        tehsil,
        qanoongoi,
        mouza,
        dcRate,
        unitOfMeasure: unitOfMeasurement,
        structureRate,
        highwayName,
        classification:
          propertyClassification?.findIndex((x) => classification === x) + 1,
        KhasraName: khasraNumber,
        effectFrom: effectiveDate.toISOString(),
      },
      data: {
        id: propertyPrevious?.Id,
        tehsilId: propertyPrevious?.tehsilId,
        districtId: propertyPrevious?.districtId,
        highwayId: propertyPrevious?.highwayId,
        mouzaId: propertyPrevious?.mouzaId,
        khasraId: propertyPrevious?.khasraId,
      },
    };
    updatePropertyDetail(requestObj);
  };

  React.useEffect(() => {
    const transformedClassfication =
      propertyClassification?.findIndex((x) => x === classification) + 1;
    if (
      ![undefined, null].includes(propertyPrevious) &&
      [
        district === propertyPrevious?.District,
        tehsil === propertyPrevious?.Tehsil,
        qanoongoi === propertyPrevious?.Qanoongoi,
        mouza === propertyPrevious?.Mouza,
        dcRate === propertyPrevious["Dc Rate"],
        unitOfMeasurement === propertyPrevious["Units of Measure"],
        structureRate === propertyPrevious["Structure Rate"],
        highwayName === propertyPrevious["highway_name"],
        khasraNumber === propertyPrevious["Khasra Number"],
        transformedClassfication === propertyPrevious.Classification,
      ].includes(false)
    ) {
      setDisableUpdate(false);
    } else {
      setDisableUpdate(true);
    }
  }, [
    district,
    tehsil,
    qanoongoi,
    mouza,
    classification,
    khasraNumber,
    dcRate,
    unitOfMeasurement,
    structureRate,
    highwayName,
  ]);

  React.useEffect(() => {
    setPropertyPrevious(history.location.state);
    //  setClassification(history?.location?.state["Classification"]);
  }, [history.location.state]);

  React.useEffect(() => {
    if (![undefined, null].includes(propertyPrevious)) {
      setDistrict(propertyPrevious?.District);
      setTehsil(propertyPrevious?.Tehsil);
      setQanoongoi(propertyPrevious?.Qanoongoi);
      setMouza(propertyPrevious?.Mouza);
      setClassification(propertyPrevious?.Classification);
      setDcRate(propertyPrevious && propertyPrevious["Dc Rate"]);
      setUnitOfMeasurement(
        propertyPrevious && propertyPrevious["Units of Measure"]
      );
      setStructureRate(propertyPrevious && propertyPrevious["Structure Rate"]);
      setHighwayName(propertyPrevious && propertyPrevious["Highway Name"]);
      setKhasraNumber(propertyPrevious["Khasra Number"]);
    }
  }, [propertyPrevious]);

  React.useEffect(() => {
    if (
      ![undefined, null].includes(updatePropertyDetailResponse?.data) &&
      updatePropertyDetailResponse?.loading === false
    ) {
      Notification(
        updatePropertyDetailResponse?.data?.data?.success,
        updatePropertyDetailResponse?.data?.data?.success ? "Success" : "Error",
        updatePropertyDetailResponse?.data?.data?.success
          ? "Record Updated"
          : "Error in Updation"
      );
      resetPropertyDetailResponse();
      if (updatePropertyDetailResponse?.data?.data?.success) {
        setIsRatesChanged(false);
      }
    }
  }, [updatePropertyDetailResponse]);

  const updateLookUpHandler = () => {
    // const dcCheck = propertyPrevious["Dc Rate"] === dcRate;
    // const structureCheck = propertyPrevious["Structure Rate"] === structureRate;
    // const isOpenEFfectiveModal =
    //   (dcCheck && !structureCheck) || (!dcCheck && structureCheck);
    const isOpenEFfectiveModal = isRatesChanged;
    if (isOpenEFfectiveModal) {
      setShowEffectiveDateModal(isOpenEFfectiveModal);
      return;
    }
    handleSubmit();
  };
  const setDistrictInLocalStorage = () => {
    localStorage.setItem(
      "districtSelected",
      JSON.stringify(propertyPrevious?.districtId)
    );
    return;
  };

  const cancelUpdateHandler = () => {
    setDistrictInLocalStorage();
    history.goBack();
  };


  function validateKhasraNumber(value) {
    if(value?.trim() !== "") {
      if (KHASRA_NUMBER_REGEX.test(value)) {
        setKhasraNumberError("")
        return true
      } else {
        setKhasraNumberError(MESSAGES.INVALID_KHASRA_NUMBER_INPUT)
        return false
      }
    } else {
      return true
    }
  }

  return (
    <React.Fragment>
      {updatePropertyDetailResponse?.loading ? (
        <div className="spin-loader">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div style={styles.titleButtonParent}>
            <div>
              <Typography className="heading">
                <span style={styles.titleText}>Lookup Table</span>/ Update
                Values
              </Typography>
            </div>
            <div>
              <Button
                style={styles.firstButton}
                danger
                color={"orange"}
                size={"large"}
                onClick={cancelUpdateHandler}
              >
                Cancel
              </Button>
              <Button
                style={!disableUpdate ? styles.uploadButton : { color: "grey" }}
                type="primary"
                size={"large"}
                onClick={updateLookUpHandler}
                disabled={disableUpdate}
              >
                UPDATE
              </Button>
              <Button
                type="primary"
                size={"large"}
                onClick={() => history.push({
                  pathname: `/admin/dc-record-history`,
                  state: propertyPrevious,
                })}
              >
                HISTORY
              </Button>
            </div>
          </div>

          <div style={{ backgroundColor: "white" }}>
            <Row style={styles.tableRow}>
              <Col span={7} style={styles.leftCol}>
                <div style={styles.tableHeader}>
                  <Title level={5}>Old Values</Title>
                </div>

                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>District</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>
                      {propertyPrevious?.District ?? "-"}
                    </span>
                  </div>
                </div>

                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>Tehsil</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>
                      {tehsil ?? "-"}
                    </span>
                  </div>
                </div>
                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>Qanoongoi</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>
                      {qanoongoi ?? "-"}
                    </span>
                  </div>
                </div>
                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>Mouza</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>
                      {mouza ?? "-"}
                    </span>
                  </div>
                </div>
                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>Classification</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>
                      {classification?.charAt(0) +
                        classification?.slice(
                          1
                        )?.toLowerCase()}
                    </span>
                  </div>
                </div>
                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>DC Rate</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>
                      {dcRate ? dcRate
                        : "-"}
                    </span>
                  </div>
                </div>
                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>Unit of Measurement</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>Marla's</span>
                  </div>
                </div>
                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>Structure Rate</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>
                      {structureRate? structureRate
                        : "-"}
                    </span>
                  </div>
                </div>
                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>Highway Name</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>
                      {highwayName? highwayName
                        : "-"}
                    </span>
                  </div>
                </div>
                <div style={styles.tableContentLeft}>
                  <div style={styles.tableContentLeftLabel}>
                    <span>Khasra No.</span>
                  </div>
                  <div>
                    <span style={styles.tableContentLeftValue}>
                      {khasraNumber
                        ?khasraNumber
                        : "-"}
                    </span>
                  </div>
                </div>
                {/* <div style={styles.tableContentLeft}>
                            <div style={styles.tableContentLeftLabel}>
                                <span >Highway Starting Point</span>
                            </div>
                            <div>
                                <span style={styles.tableContentLeftValue} >{highwayStPnt ?? '-'}</span>
                            </div>
                        </div>
                        <div style={styles.tableContentLeft}>
                            <div style={styles.tableContentLeftLabel}>
                                <span >Highway Ending Point</span>
                            </div>
                            <div>
                                <span style={styles.tableContentLeftValue} >{highwayEndPnt ?? '-'}</span>
                            </div>
                        </div> */}
              </Col>
              <Col span={16} style={styles.rightCol}>
                <div style={styles.tableHeader}>
                  <Title level={5}>Enter New Values</Title>
                </div>

                <div style={styles.tableContentRight}>
                  <InputLabel
                    value={district} //value of all zones that we should assign
                    labelText="District"
                    active={district}
                  >
                    <Input
                      disabled={true}
                      style={styles.tableContentRightValue}
                      value={district}
                      onChange={(x) => setDistrict(x.target.value)}
                    />
                  </InputLabel>
                </div>

                <div style={styles.tableContentRight}>
                  <InputLabel
                    value={tehsil} //value of all zones that we should assign
                    labelText="Tehsil"
                  >
                    <Input
                      style={styles.tableContentRightValue}
                      value={tehsil}
                      onChange={(x) => setTehsil(x.target.value)}
                    />
                  </InputLabel>
                </div>
                <div style={styles.tableContentRight}>
                  <InputLabel
                    value={qanoongoi} //value of all zones that we should assign
                    labelText="Qanoongoi"
                  >
                    <Input
                      style={styles.tableContentRightValue}
                      value={qanoongoi}
                      onChange={(x) => setQanoongoi(x.target.value)}
                    />
                  </InputLabel>
                </div>
                <div style={styles.tableContentRight}>
                  <InputLabel
                    value={mouza} //value of all zones that we should assign
                    labelText="Mouza"
                  >
                    <Input
                      style={styles.tableContentRightValue}
                      value={mouza}
                      onChange={(x) => setMouza(x.target.value)}
                    />
                  </InputLabel>
                </div>
                <div style={styles.tableContentRight}>
                  <InputLabel value={classification} labelText="Classification">
                    <Select
                      value={classification}
                      onChange={(x) => setClassification(x)}
                      size="large"
                      //  defaultValue={propertyPrevious?.Classification}
                    >
                      {propertyClassification?.map((x) => (
                        <Select.Option value={x}>{x}</Select.Option>
                      ))}
                    </Select>
                  </InputLabel>
                </div>
                <div style={styles.tableContentRight}>
                  <InputLabel
                    value={dcRate} //value of all zones that we should assign
                    labelText="DC Rate"
                  >
                    <Input
                      style={styles.tableContentRightValue}
                      value={dcRate}
                      onChange={(x) => onDcRateChange(x.target.value)}
                    />
                  </InputLabel>
                </div>
                {/* <div style={styles.tableContentRight}>
                  <InputLabel
                    value={unitOfMeasurement}
                    labelText="Unit of Measurement"
                  >
                    <Select
                      value={unitOfMeasurement}
                      onChange={(x) => setUnitOfMeasurement(x)}
                      size="large"
                    >
                      {measurementUnits?.map((x) => (
                        <Select.Option value={x}>{x}</Select.Option>
                      ))}
                    </Select>
                  </InputLabel>
                </div> */}
                <div style={styles.tableContentRight}>
                  <InputLabel
                    value={structureRate} //value of all zones that we should assign
                    labelText="Structure Rate"
                  >
                    <Input
                      style={styles.tableContentRightValue}
                      value={structureRate}
                      onChange={(x) => onStructureRateChange(x.target.value)}
                    />
                  </InputLabel>
                </div>
                <div style={styles.tableContentRight}>
                  <InputLabel
                    value={highwayName} //value of all zones that we should assign
                    labelText="Highway Name"
                  >
                    <Input
                      style={styles.tableContentRightValue}
                      value={highwayName}
                      disabled
                      //  defaultValue={propertyPrevious?.["Highway Name"]}
                      onChange={(x) => setHighwayName(x.target.value)}
                    />
                  </InputLabel>
                </div>
                <div style={styles.tableContentRight}>
                  <InputLabel
                    value={khasraNumber} //value of all zones that we should assign
                    labelText="Khasra No."
                    active={
                      propertyPrevious && propertyPrevious["Khasra Number"]
                    }
                  >
                    <Input
                      style={styles.tableContentRightValue}
                      value={khasraNumber}
                      onChange={(x) => setKhasraNumber(x.target.value)}
                    />
                    {/* <Select mode="tags" tokenSeparators={['\n']} size={'default'} dropdownStyle={{ display: 'none' }} style={{ width: '100%', height: "100%" }} onChange={(x) => onChangeKhasras(x)}
                                            value={transformKhasrasToTag(khasraNumber ?? null)}
                                        > </Select> */}
                  </InputLabel>
                  { khasraNumberError && <p className="error-input"> {khasraNumberError} </p>  }
                </div>
                {/* <div style={styles.tableContentRight}>
                            <InputLabel
                                value={highwayStPnt} //value of all zones that we should assign
                                labelText="Highway Starting Point"
                            >
                                <Input
                                    style={styles.tableContentRightValue}
                                    value={
                                        highwayStPnt
                                    }
                                    onChange={(x) => setHighwayStPnt(x.target.value)}
                                />
                            </InputLabel>
                        </div>
                        <div style={styles.tableContentRight}>
                            <InputLabel
                                value={highwayEndPnt} //value of all zones that we should assign
                                labelText="Highway Ending Point"
                            >
                                <Input
                                    style={styles.tableContentRightValue}
                                    value={
                                        highwayEndPnt
                                    }
                                    onChange={(x) => setHighwayEndPnt(x.target.value)}
                                />
                            </InputLabel>
                        </div> */}
              </Col>
              <Col flex={"auto"} style={{ backgroundColor: "white" }}></Col>
            </Row>
          </div>

          <Modal
            title="Effect from (new table effective date)"
            visible={showEffectiveDateModal}
            okText={"UPDATE"}
            onOk={() => {
              handleSubmit();
              setShowEffectiveDateModal(false);
            }}
            onCancel={() => {
              setShowEffectiveDateModal(false);
            }}
            // okButtonProps={{ style: [undefined, null].includes(reassignedETO) ? { display: 'none' } : { display: '' } }}
            width="30%"
          >
            <div>
              <Row gutter={16}>
                <Col span={24} style={{ marginBottom: "25px" }}>
                  <div>
                    <Typography.Text>
                      The changes you have made will impact the ATV calculation
                      of relevant properties.
                    </Typography.Text>
                  </div>
                  <div>
                    <Typography.Text>
                      Please select an "effect from" date for the new rates to
                      be applicable
                    </Typography.Text>
                  </div>
                </Col>
                <Col span={24} style={{ paddingLeft: "20px" }}>
                  <Typography.Text
                    type="strong"
                    style={{ marginRight: "20px" }}
                  >
                    Date :
                  </Typography.Text>
                  <DatePicker
                    defaultValue={moment()}
                    disabledDate={(current) => {
                      let customDate = moment().format("YYYY-MM-DD");
                      return (
                        current && current < moment(customDate, "YYYY-MM-DD")
                      );
                    }}
                    onChange={(x) => setEffectiveDate(moment(x))}
                    allowClear={false}
                  />
                </Col>
              </Row>
            </div>
          </Modal>
        </>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = ({
  user: user,
  property: { updatePropertyDetailResponse },
}) => ({
  user,
  updatePropertyDetailResponse,
});

const mapDispatchToProps = (dispatch) => ({
  updatePropertyDetail: bindActionCreators(updatePropertyDetail, dispatch),
  resetPropertyDetailResponse: bindActionCreators(
    resetPropertyDetailResponse,
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(LookupTableEdit);
